import React, { FC, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import { setDeDataStore } from 'src/fetch/data/store';
import { settlementNtsDataStore, ntsFileDataStore } from 'src/store/settlementInfo';
import { gridOption } from './gridOption';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxPdf: FC<Props> = ({ data }) => {
  // const dataSet = {};
  // const setData = data;
  // NTS 업로드파일 데이터
  const ntsFileData = ntsFileDataStore((state: any) => state.result)?.data || [];
  const ntsFileState = ntsFileDataStore((state: any) => state.bind);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  const totalCount = 1;
  // const bindStateData = setDeDataStore(state => state.bindData);
  const optionSet: any = gridOption(ntsFileData, totalCount, ntsFileState);
  const stateOption: any = {
    label: optionSet.label || [],
    data: optionSet.data || [],
    styleDef: optionSet.styleDef,
    rowStyleDef: {},
    totalCount,
  };

  const rowClickEvt = () => {};
  const pagingClick = () => {};
  const sortClickEvt = () => {};

  return (
    <div className="_step_c_hometax_pdf">
      <div className="_content">
        <TableGrid
          gridOption={stateOption}
          rowClickEvt={rowClickEvt}
          pagingClick={pagingClick}
          sortClickEvt={sortClickEvt}
          dataType="object"
          viewType="type1"
          noContentStyleDef={{ height: '150px', minHeight: '150px' }}
          noContentText="등록된 내용이 없습니다."
        />
      </div>
    </div>
  );
};

export default HomeTaxPdf;
